import { render, staticRenderFns } from "./coderInpatientResponses.vue?vue&type=template&id=7350b615&scoped=true&"
import script from "./coderInpatientResponses.vue?vue&type=script&lang=js&"
export * from "./coderInpatientResponses.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientResponses.vue?vue&type=style&index=0&id=7350b615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350b615",
  null
  
)

export default component.exports